import { DELETE_API, GET_API, PATCH_API, POST_API } from "../../Functionalities/APIs";
import {
  homeBannerItemsUrl, homeBannerReorderUrl, homeBannerSectionsUrl, homeBannersAdminUrl,
} from "../../Constants/apiUrls";

const form = (fields) => {
  const body = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined) return;
    body.append(key, value === null ? "" : value);
  });
  return body;
};

const withFranchise = (fields, franchiseId) => (franchiseId ? { ...fields, franchise_id: franchiseId } : fields);

const linkFields = (link) =>
  !link ? {} : link.type === "item" ? { item_id: link.id } : { branch_id: link.id };

const reply = (result) => (result && result.data) || { Status: false, Error: "The server did not answer" };

export const listPlacement = async (placement, franchiseId) => {
  const params = `placement=${placement}${franchiseId ? `&franchise_id=${franchiseId}` : ""}`;
  return reply(await GET_API("", params, homeBannersAdminUrl));
};

export const getSection = async (id) => reply(await GET_API("", "", `${homeBannerSectionsUrl}${id}/`));

export const createSection = async ({ placement, title, logo, visibleFrom, visibleTo, franchiseId }) =>
  reply(await POST_API(
    form(withFranchise({ placement, title, logo, visible_from: visibleFrom, visible_to: visibleTo }, franchiseId)),
    "",
    homeBannerSectionsUrl,
  ));

export const updateSection = async (id, { title, logo, isActive, visibleFrom, visibleTo }) =>
  reply(await PATCH_API(
    form({ title, logo, is_active: isActive, visible_from: visibleFrom, visible_to: visibleTo }),
    "",
    `${homeBannerSectionsUrl}${id}/`,
  ));

export const deleteSection = async (id) => reply(await DELETE_API("", "", `${homeBannerSectionsUrl}${id}/`));

export const createBanner = async ({ placement, sectionId, picture, link, franchiseId }) =>
  reply(await POST_API(
    form(withFranchise({ placement, section_id: sectionId, picture, ...linkFields(link) }, franchiseId)),
    "",
    homeBannerItemsUrl,
  ));

export const updateBanner = async (id, { picture, link, isActive }) =>
  reply(await PATCH_API(
    form({ picture, is_active: isActive, ...linkFields(link) }),
    "",
    `${homeBannerItemsUrl}${id}/`,
  ));

export const deleteBanner = async (id) => reply(await DELETE_API("", "", `${homeBannerItemsUrl}${id}/`));

export const reorderStrip = async (placement, ids, franchiseId) =>
  reply(await POST_API(form(withFranchise({ placement, ids: JSON.stringify(ids) }, franchiseId)), "", homeBannerReorderUrl));
